<template>
  <div>
    <el-carousel :height="height" :autoplay="false" :arrow="list.length > 1 ? 'always' : 'never'" :indicator-position="list.length > 1 ? '' : 'none'" trigger="click" class="carousel" :class="theme">
      <!-- fileType 文件类型 1，图片 2视频 -->
      <template v-if="list.length > 0">
        <el-carousel-item v-for="item in list" :key="item.id">
          <div class="carousel-item">
            <img :src="item.path" class="pic" v-if="item.fileType == 1" />
            <Video :item="item" v-if="item.fileType == 2" />
            <div class="tools">
              <div class="left">
                <div class="fav" :class="{ active: parentItem.collectionId }" @click="toggleCollection" v-if="theme != 'banner'">
                  <div class="icon-svg">
                    <svg width="60px" height="60px" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="页面-1" stroke="none" stroke-width="1" fill-rule="evenodd">
                        <g id="icon-fav" fill-rule="nonzero">
                          <circle id="椭圆形" fill="#222131" cx="30" cy="30" r="30"></circle>
                          <path
                            d="M30,20.88 C30.6980694,19.5746356 31.6381162,18.4140002 32.77,17.46 C34.3030931,16.2594335 36.2145788,15.645914 38.16,15.73 C43.1305627,15.73 47.16,19.7594373 47.16,24.73 C47.2940245,28.6586057 45.8206438,32.4720616 43.08,35.29 C40.37,38.2 36.23,40.86 30.39,44.12 C30.109009,44.2846471 29.760991,44.2846471 29.48,44.12 C24.25,40.94 20.14,38.3 17.3,35.38 C14.3738788,32.6324486 12.7342262,28.7836179 12.78,24.77 C12.78,19.7994373 16.8094373,15.77 21.78,15.77 C25.78,15.77 27.96,17.49 29.93,20.92"
                            id="路径"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <ShareBtn :shareUrl="shareUrl"></ShareBtn>
              </div>
              <div class="fullscreen" @click="fullscreen">
                <img src="../assets/images/icon-fullscreen.svg" width="45" />
              </div>
            </div>
            <div class="book-now" v-if="name == 'home' && item.typeId">
              <div class="btn btn-theme" @click="toBook(item.typeId)">{{ ts('BOOK NOW')['BOOK NOW'] }}</div>
            </div>
          </div>
        </el-carousel-item>
      </template>
      <!-- <el-carousel-item v-else>
        <div class="carousel-item">
          <img src="../assets/pic/banner.jpg" class="pic" />
          <div class="tools">
            <div class="left">
              <div class="fav" :class="{ active: parentItem.collectionId }" @click="toggleCollection" v-if="theme != 'banner'">
                <img src="../assets/images/icon-fav.svg" width="45" />
              </div>
              <ShareBtn :shareUrl="shareUrl"></ShareBtn>
            </div>
            <div class="fullscreen" @click="fullscreen">
              <img src="../assets/images/icon-fullscreen.svg" width="45" />
            </div>
          </div>
        </div>
      </el-carousel-item> -->
    </el-carousel>
    <el-dialog :visible.sync="isShow" width="1080px" class="dialog-carousel" :append-to-body="true" :destroy-on-close="true">
      <el-carousel height="607.5px" :autoplay="false" trigger="click" arrow="always" class="carousel" :class="theme">
        <!-- fileType 文件类型 1，图片 2视频 -->
        <template v-if="list.length > 0">
          <el-carousel-item v-for="item in list" :key="item.id">
            <div class="carousel-item">
              <img :src="item.path" class="pic" v-if="item.fileType == 1" />
              <Video :item="item" v-if="item.fileType == 2" />
            </div>
          </el-carousel-item>
        </template>
        <!-- <el-carousel-item v-else>
          <div class="carousel-item">
            <img src="../assets/pic/banner.jpg" class="pic" />
          </div>
        </el-carousel-item> -->
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import Video from '@/components/Video.vue'
import ShareBtn from '@/components/ShareBtn.vue'

export default {
  name: 'Carousel',
  props: ['height', 'theme', 'list', 'name', 'parentItem', 'type'],
  mixins: [LanguagePackage],
  components: {
    Video,
    ShareBtn,
  },
  data() {
    return {
      isShow: false,
    }
  },
  computed: {
    shareUrl() {
      let url = window.location.href
      if (this.$route.name == 'User') {
        url = window.location.origin
      }
      return url
    },
  },
  methods: {
    // 预定酒店
    toBook(id) {
      this.$router.push(`/hotel/${id}`)
    },
    fullscreen() {
      this.isShow = true
    },
    toggleCollection() {
      const { collectionId } = this.parentItem
      if (collectionId) {
        this.delCollection(collectionId)
      } else {
        this.addCollection()
      }
    },
    // 收藏
    addCollection() {
      console.log(this.parentItem)
      // dataType 酒店 2，房型 3，商品 11，活动 12，服务 13
      const { productType, singleProductId, houseResourcesId, roomTypeId } = this.parentItem
      let dataType = null
      let relationId = null

      // 商品 11，活动 12，服务 13
      // productType, singleProductId
      // productType 1 商品 2 活动 3 服务
      if (this.type == 'product') {
        if (productType == 1) {
          dataType = '11'
        } else if (productType == 2) {
          dataType = '12'
        } else if (productType == 3) {
          dataType = '13'
        }
        relationId = singleProductId
      }

      // 房源，酒店 2
      // houseResourcesId
      if (this.type == 'hotel') {
        dataType = '2'
        relationId = houseResourcesId
      }

      // 房型 3
      // roomTypeId
      if (this.type == 'room') {
        dataType = '3'
        relationId = roomTypeId
      }

      if (dataType && relationId) {
        postAction(`/user/api/addCollection`, {
          dataType,
          relationId,
        }).then((res) => {
          this.$message({
            message: this.translate('Collection is successful!'),
            type: 'success',
          })
          this.parentItem.collectionId = res.result
        })
      }
    },
    delCollection(id) {
      getAction(`/user/api/delCollection`, {
        id,
      }).then((res) => {
        this.parentItem.collectionId = null
        this.$message({
          message: this.translate('Collection canceled successfully!'),
          type: 'success',
        })
      })
    },
    getShareUrl() {
      console.log(this.parentItem)
      let url = window.location.href
      const urlOrigin = window.location.origin
      if (this.parentItem) {
        const { productType, singleProductId, houseResourcesId, pageId } = this.parentItem

        // productType 1 商品 2 活动 3 服务
        if (this.type == 'product') {
          url = `${urlOrigin}/product/${pageId}?type=${productType}`
        }

        // 房源，酒店 2
        // houseResourcesId
        if (this.type == 'hotel') {
          url = `${urlOrigin}/hotel/${houseResourcesId}`
        }

        // 房型 3
        // TODO 接口返回 houseResourcesId 为 null
        if (this.type == 'room') {
          url = `${urlOrigin}/hotel/${houseResourcesId}`
        }
      }

      return url
    },
  },
}
</script>

<style scoped lang="scss">
.carousel-item {
  .book-now {
    position: absolute;
    bottom: 80px;
    left: 0;
    width: 100%;
    text-align: center;
  }
}
.tools {
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 30px;
  .left {
    display: flex;
    align-items: center;
  }
  .fav {
    margin-right: 30px;
  }
  .fav,
  .share,
  .fullscreen {
    cursor: pointer;
  }
  .icon-svg {
    svg {
      width: 45px;
      fill: #fff;
    }
  }
}
</style>
